import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const name = 'app';

export interface AppSliceState {
  currentQuestionId: string | null;
}

const initialState: AppSliceState = {
  currentQuestionId: null,
};

export const appSlice = createSlice({
  name,
  initialState,
  reducers: {
    setCurrentQuestionId: (
      state,
      action: PayloadAction<Pick<AppSliceState, 'currentQuestionId'>>,
    ) => {
      state.currentQuestionId = action.payload.currentQuestionId;
    },
  },
});

export const { setCurrentQuestionId } = appSlice.actions;
